import { forwardRef, useEffect, useImperativeHandle } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";
import { genTemplateBodyText } from "@components/utils/TableTemplateBodyGenerator";
import useIsMobile from "../../../../hooks/useIsMobile";
import { useAPIGetJabatanSelector } from "../api/api-get-jabatan-selector";
import JabatanSelectorFilter from "./jabatan-selector-filter";

// Converts the `selected` prop into the DataTable selection (array or single row)
const normalizeSelected = (selected, multiple) => {
  if (selected === null || selected === undefined) return multiple ? [] : null;

  const list = Array.isArray(selected) ? selected : [selected];
  const valid = list.filter((row) => row !== null && row !== undefined);

  if (valid.length === 0) return multiple ? [] : null;
  return multiple ? valid : valid[0];
};

const JabatanSelectorList = forwardRef((props, ref) => {
  const { visible, additionalFilter, multiple, selected } = props;

  const isMobile = useIsMobile();

  const {
    loading,
    listData,
    fetchListData,
    filterValue,
    setFilterValue,
    handleOnClickRefresh,
    handleOnPage,
    paging,
    listSelected,
    setListSelected,
  } = useAPIGetJabatanSelector({ additionalFilter });

  useImperativeHandle(ref, () => ({
    getSelectedData: () => {
      return listSelected;
    },
  }));

  // use effect section

  useEffect(() => {
    if (visible) {
      setListSelected(normalizeSelected(selected, multiple));
      fetchListData({ page: 1, take: paging.take });
    }
  }, [visible]);

  //  custom ui section

  const kodeBodyTemplate = (row) => {
    return genTemplateBodyText({
      row: row,
      field: "kode",
      defaultEmpty: "-",
    });
  };

  const namaBodyTemplate = (row) => {
    return genTemplateBodyText({
      row: row,
      field: "nama",
      defaultEmpty: "-",
    });
  };

  return (
    <div className="col-start-start w-full gap-4">
      {/* filter section */}
      <JabatanSelectorFilter
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        onClickRefresh={handleOnClickRefresh}
      />

      {/* table section */}
      <div className="col-start-start w-full gap-2 pb-2">
        <DataTable
          dataKey="id"
          value={listData}
          loading={loading}
          showGridlines
          stripedRows
          selection={listSelected}
          onSelectionChange={(e) => setListSelected(e.value)}
          className="w-100"
        >
          <Column
            selectionMode={multiple ? "multiple" : "single"}
            headerStyle={{ width: "3rem" }}
          />
          <Column
            field="no"
            header="#"
            className="text-center"
            headerClassName="w-[4rem]"
            alignHeader="center"
          />
          <Column field="kode" header="Kode" body={kodeBodyTemplate} />
          <Column field="nama" header="Nama" body={namaBodyTemplate} />
        </DataTable>
        {!isMobile ? (
          <Paginator
            first={parseInt(paging.take) * (paging.page - 1)}
            rows={parseInt(paging.take)}
            totalRecords={parseInt(paging.total)}
            rowsPerPageOptions={[5, 10, 20, 50]}
            onPageChange={handleOnPage}
            className="w-full justify-center"
          />
        ) : (
          <Paginator
            first={parseInt(paging.take) * (paging.page - 1)}
            rows={parseInt(paging.take)}
            totalRecords={parseInt(paging.total)}
            template="PrevPageLink CurrentPageReport NextPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            onPageChange={handleOnPage}
            className="w-full justify-center"
          />
        )}
      </div>
    </div>
  );
});

export default JabatanSelectorList;
